import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import store from '../store/index';
import productParam from '@/utils/vipRedirect'

const DEFAULT_API_BASE_URL = 'https://test-api.vipshop.elco-cloud.cn/';

class HttpRequest {
    private readonly baseUrl: string;

    /**
     * 初始化请求基础地址，优先读取构建环境注入的接口域名。
     */
    constructor() {
        this.baseUrl = process.env.VUE_APP_API_BASE_URL || DEFAULT_API_BASE_URL
    }

    /**
     * 生成请求默认配置，统一附带鉴权与品牌头信息。
     */
    getInsideConfig() {
        console.log('store2',store.state.token)
        const config = {
            baseURL: this.baseUrl,// 所有的请求地址前缀部分(没有后端请求不用写)  
            timeout: 80000, // 请求超时时间(毫秒)
            withCredentials: true,// 异步请求携带cookie
            headers: {
                'Content-Type': 'application/json',
                'Access-token': window.localStorage.getItem(`accessToken${window.localStorage.getItem('currentState')}`),
                'brand': store.state.currentState === 'clinique' || window.localStorage.getItem('currentState') === 'clinique' ? 'CL' : 'OR',
                'X-Requested-With': 'XMLHttpRequest',
            },
        }
        return config
    }

    /**
     * 注册请求与响应拦截器，统一处理返回值和鉴权失效场景。
     */
    interceptors(instance: AxiosInstance, url: string | number | undefined) {
        
        instance.interceptors.request.use(config => {
            return config
        }, (error: any) => {
            console.log('error111==>', error)
            return Promise.reject(error)
        })

        //响应拦截
        instance.interceptors.response.use(res => {
            //返回数据
            const { data } = res
            console.log('返回数据处理', res)
            return data
        }, (error: any) => {
            console.log('error111==>', error)
            if (error && error.response.data) {
                switch (error.response.data.errorCode) {
                  case 401: {
                    const currentUrl = new URL(window.location.href);
                    window.localStorage.clear()
                    const _params = currentUrl.search.split('state=')[1];
                    if(_params) {
                        const _brand = _params.split('&')[0];
                        window.location.href = productParam(_brand);
                    }else {
                        const currnetState = window.localStorage.getItem('currentState')
                        window.location.href = productParam(currnetState);
                    }
                    break;
                  }
                  default:
                }
            }
            return Promise.reject(error)

        })
    }

    /**
     * 发起请求，并在请求前合并默认配置。
     */
    request(options: AxiosRequestConfig) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(), options)
        this.interceptors(instance, options.url)
        return instance(options)
    }
}

const http = new HttpRequest()

export default http;
